export default "__VITE_ASSET__IyAMPBav__"